import { Component, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {

  constructor(
      private afFunctions: AngularFireFunctions,
      private snackBar: MatSnackBar
    ) {
    
  }

  usuarios;

  usuario;  

  displayedColumns = ["phoneNumber", "email", "displayName", "creationTime", "lastSignInTime", "rol", "options"];

  fnListUsers;

  fnCreateUser;

  fnUpdateUser;

  fnDeleteUser;

  ngOnInit() {
    this.fnListUsers  = this.afFunctions.httpsCallable('users-listUsers');
    this.fnCreateUser = this.afFunctions.httpsCallable('users-createUser');
    this.fnUpdateUser = this.afFunctions.httpsCallable("users-updateUser");
    this.fnDeleteUser = this.afFunctions.httpsCallable("users-deleteUser");
    //
    this.showList();
  }

  showCreate(){
    this.usuario = {
      email: "",
      password: "",
      claims: {
        rol: ""
      }
    };
  }

  showUpdate(usuario){
    this.usuario = usuario;
    console.table(this.usuario);
    if( !('claims' in this.usuario) || this.usuario.claims == null || !('rol' in this.usuario.claims) ){      
      this.usuario.claims = {
        rol: ""
      };             
    }
  }

  showDelete(usuario){    
    if(confirm("¿Esta seguro de querer eliminar a este usuario?")){
      this.fnDeleteUser(usuario)
      .toPromise()
      .then(
        (_) => {        
          this.showList();
          this.snackBar.open("Se ha eliminado el usuario correctamente","Entiendo",{duration: 2000});
        }
      )
      .catch(
        (error)=>{
          this.snackBar.open("Error inesperado eliminando el usuario","Entiendo",{duration: 2000});
        }
      );
    }
  }

  

  showList(){
    this.usuarios = this.fnListUsers({});
    this.usuario = null;
  }
  
  create(){
    this.fnCreateUser(this.usuario)
    .toPromise()
    .then(
      (_) => {        
        this.showList();
      }
    )
    .catch(
      (fnError) => {                
        //TODO: Buscar como se devuelve el error con este tema de los promises
        this.snackBar.open("Error inesperado creando el usuario, verifique que no existe e intente nuevamente","Entiendo",{duration: 2000});
      }
    );
  }

  update(){
    this.fnUpdateUser(this.usuario)
    .toPromise()
    .then(
      (_) => {        
        this.showList();
      }
    )
    .catch(
      (fnError) => {                
        //TODO: Buscar como se devuelve el error con este tema de los promises
        this.snackBar.open(
          "Error inesperado actualizando los datos del usuario",
          "Entiendo",
          {duration: 2000}
        );
      }
    );
  }
}
